export const LEVELS: string[][] = [
    [
        "    #####",
        "    #   #",
        "    #$  #",
        "  ###  $##",
        "  #  $ $ #",
        "### # ## #   ######",
        "#   # ## #####  ..#",
        "# $  $          ..#",
        "##### ### #@##  ..#",
        "    #     #########",
        "    #######"
    ],
    [
        " ###  #############",
        "##@####       #   #",
        "# $$   $$  $ $ ...#",
        "#  $$$#    $  #...#",
        "# $   # $$ $$ #...#",
        "###   #  $    #...#",
        "#     # $ $ $ #...#",
        "#    ###### ###...#",
        "## #  #  $ $  #...#",
        "#  ## # $$ $ $##..#",
        "# ..# #  $      #.#",
        "# ..# # $$$ $$$ #.#",
        "##### #       # #.#",
        "    # ######### #.#",
        "    #           #.#",
        "    ###############"
    ],
    [
        "          ####",
        "     #### #  #",
        "   ### @###$ #",
        "  ##      $  #",
        " ##  $ $$## ##",
        " #  #$##     #",
        " # # $ $$ # ###",
        " #   $ #  # $ #####",
        "####    #  $$ #   #",
        "#### ## $         #",
        "#.    ###  ########",
        "#.. ..# ####",
        "#...#.#",
        "#.....#",
        "#######"
    ],
    [
        "################ ",
        "#              # ",
        "# # ######     # ",
        "# #  $ $ $ $#  # ",
        "# #   $@$   ## ##",
        "# #  $ $ $###...#",
        "# #   $ $  ##...#",
        "# ###$$$ $ ##...#",
        "#     # ## ##...#",
        "#####   ## ##...#",
        "    #####     ###",
        "        #     #  ",
        "        #######  "
    ],
    [
        "   #########       ",
        "  ##   ##  #####   ",
        "###     #  #    ###",
        "#  $ #$ #  #  ... #",
        "# # $#@$## # #.#. #",
        "#  # #$  #    . . #",
        "# $    $ # # #.#. #",
        "#   ##  ##$ $ . . #",
        "# $ #   #  #$#.#. #",
        "## $  $   $  $... #",
        " #$ ######    ##  #",
        " #  #    ##########",
        " ####              "
    ],
    [
        "       #######    ",
        " #######     #    ",
        " #     # $@$ #    ",
        " #$$ #   #########",
        " # ###......##   #",
        " #   $......## # #",
        " # ###......     #",
        "##   #### ### #$##",
        "#  #$   #  $  # # ",
        "#  $ $$$  # $## # ",
        "#   $ $ ###$$ # # ",
        "#####     $   # # ",
        "    ### ###   # # ",
        "      #     #   # ",
        "      ########  # ",
        "             #### "
    ],
    [
        "   ########      ",
        "   #   #  #      ",
        "   #  $   #      ",
        " ### #$   ####   ",
        " #  $  ##$   #   ",
        " #  # @ $ # $#   ",
        " #  #      $ ####",
        " ## ####$##     #",
        " # $#.....# #   #",
        " #  $..**. $# ###",
        "##  #.....#   #  ",
        "#   ### #######  ",
        "# $$  #  #       ",
        "#  #     #       ",
        "######   #       ",
        "     #####       "
    ],
    [
        "#####",
        "#   ##",
        "#    #  ####",
        "# $  ####  #",
        "#  $$ $   $#",
        "###@ #$    ##",
        " #  ##  $ $ ##",
        " # $  ## ## .#",
        " #  #$##$  #.#",
        " ###   $..##.#",
        "  #    #.*...#",
        "  # $$ #.....#",
        "  #  #########",
        "  #  #",
        "  ####"
    ],
    [
        "   ##########",
        "   #..  #   #",
        "   #..      #",
        "   #..  #  ####",
        "  #######  #  ##",
        "  #            #",
        "  #  #  ##  #  #",
        "#### ##  #### ##",
        "#  $  ##### #  #",
        "# # $  $  # $  #",
        "# @$  $   #   ##",
        "#### ## #######",
        "   #    #",
        "   ######"
    ],
    [
        "     ###########",
        "     #  .  #   #",
        "     # #.    @ #",
        " ##### ##..# ####",
        "##  # ..###     ###",
        "# $ #...   $ #  $ #",
        "#    .. ##  ## ## #",
        "####$##$# $ #   # #",
        "  ## #    #$ $$ # #",
        "  #  $ # #  # $## #",
        "  #               #",
        "  #  ###########  #",
        "  ####         ####"
    ],
    [
        "  ######",
        "  #   @####",
        "##### $   #",
        "#   ##    ####",
        "# $ #  ##    #",
        "# $ #  ##### #",
        "## $  $    # #",
        "## $ $ ### # #",
        "## #  $  # # #",
        "## # #$#   # #",
        "## ###   # # ######",
        "#  $  #### # #....#",
        "#    $    $   ..#.#",
        "####$  $# $   ....#",
        "#       #  ## ....#",
        "###################"
    ],
    [
        "############",
        "#..  #     ###",
        "#..  # $  $  #",
        "#..  #$####  #",
        "#..    @ ##  #",
        "#..  # #  $ ##",
        "###### ##$ $ #",
        "  # $  $ $ $ #",
        "  #    #     #",
        "  ############"
    ],
    [
        "    ##########",
        "#####        ####",
        "#     #   $  #@ #",
        "# #######$####  ###",
        "# #    ## #  #$ ..#",
        "# # $     #  #  #.#",
        "# # $  #     #$ ..#",
        "# #  ### ##     #.#",
        "# ###  #  #  #$ ..#",
        "# #    #  ####  #.#",
        "# #$   $  $  #$ ..#",
        "#    $ # $ $ #  #.#",
        "#### $###    #$ ..#",
        "   #    $$ ###....#",
        "   #      ## ######",
        "   ########"
    ],
    [
        "#########",
        "#       #",
        "#       ####",
        "## #### #  #",
        "## #@##    #",
        "# $$$ $  $$#",
        "#  # ## $  #",
        "#  # ##  $ ####",
        "####  $$$ $#  #",
        " #   ##   ....#",
        " # #   # #.. .#",
        " #   # # ##...#",
        " ##### $  #...#",
        "     ##   #####",
        "      #####"
    ],
    [
        "######     ####",
        "#    #######  #####",
        "#   $#  #  $  #   #",
        "#  $  $  $ # $ $  #",
        "##$ $   # @# $    #",
        "#  $ ########### ##",
        "# #   #.......# $#",
        "# ##  # ......#  #",
        "# #   $........$ #",
        "# # $ #.... ..#  #",
        "#  $ $####$#### $#",
        "# $   ### $   $  ##",
        "# $     $ $  $    #",
        "## ###### $ ##### #",
        "#         #       #",
        "###################"
    ],
    [
        "    #######",
        "    #  #  ####",
        "##### $#$ #  ##",
        "#.. #  #  #   #",
        "#.. # $#$ #  $####",
        "#.  #     #$  #  #",
        "#..   $#  # $    #",
        "#..@#  #$ #$  #  #",
        "#.. # $#     $#  #",
        "#.. #  #$$#$  #  ##",
        "#.. # $#  #  $#$  #",
        "#.. #  #  #   #   #",
        "##. ####  #####   #",
        " ####  ####   #####"
    ],
    [
        "###############",
        "#..........  .####",
        "#..........$$.#  #",
        "###########$ #   ##",
        "#      $  $     $ #",
        "## ####   #  $ #  #",
        "#      #   ##  # ##",
        "#  $#  # ##  ### ##",
        "# $ #$###    ### ##",
        "###  $ #  #  ### ##",
        "###    $ ## #  # ##",
        " # $  #  $  $ $   #",
        " #  $  $#$$$  #   #",
        " #  #  $      #####",
        " # @##  #  #  #",
        " ##############"
    ],
    [
        "####",
        "#  ##############",
        "#  #   ..#......#",
        "#  # # ##### ...#",
        "##$#    ........#",
        "#   ##$######  ####",
        "# $ #     ######@ #",
        "##$ # $   ######  #",
        "#  $ #$$$##       #",
        "#      #    #$#$###",
        "# #### #$$$$$    #",
        "# #    $     #   #",
        "# #   ##        ###",
        "# ######$###### $ #",
        "#        #    #   #",
        "##########    #####"
    ],
    [
        " #######",
        " #  #  #####",
        "##  #  #...###",
        "#  $#  #...  #",
        "# $ #$$ ...  #",
        "#  $#  #... .#",
        "#   # $########",
        "##$       $ $ #",
        "##  #  $$ #   #",
        " ######  ##$$@#",
        "      #      ##",
        "      ########"
    ],
    [
        " #################",
        " #...   #    #   ##",
        "##.....  $## # #$ #",
        "#......#  $  #    #",
        "#......#  #  # #  #",
        "######### $  $ $  #",
        "  #     #$##$ ##$##",
        " ##   $    # $    #",
        " #  ## ### #  ##$ #",
        " # $ $$     $  $  #",
        " # $    $##$ ######",
        " #######  @ ##",
        "       ######"
    ],
    [
        "         #####",
        "     #####   #",
        "    ## $  $  ####",
        "##### $  $ $ ##.#",
        "#       $$  ##..#",
        "#  ###### ###.. #",
        "## #  #    #... #",
        "# $   #    #... #",
        "#@ #$ ## ####...#",
        "####  $ $$  ##..#",
        "   ##  $ $  $...#",
        "    # $$  $ #  .#",
        "    #   $ $  ####",
        "    ######   #",
        "         #####"
    ],
    [
        "#####",
        "#   ##",
        "# $  #########",
        "## # #       ######",
        "## #   $#$#@  #   #",
        "#  #      $ #   $ #",
        "#  ### ######### ##",
        "#  ## ..*..... # ##",
        "## ## *.*..*.* # ##",
        "# $########## ##$ #",
        "#  $   $  $    $  #",
        "#  #   #   #   #  #",
        "###################"
    ],
    [
        "        ########",
        "        #     @#",
        "        # $#$ ##",
        "        # $  $#",
        "        ##$ $ #",
        "######### $ # ###",
        "#....  ## $  $  #",
        "##...    $  $   #",
        "#....  ##########",
        "########"
    ],
    [
        "       ###########",
        "       #   #     #",
        "#####  #     $ $ #",
        "#   ##### $## # ##",
        "# $ ##   # ## $  #",
        "# $  @$$ # ##$$$ #",
        "## ###   # ##    #",
        "## #   ### #####$#",
        "## #     $  #....#",
        "#  ### ## $ #....##",
        "# $   $ #   #..$. #",
        "#  ## $ #  ##.... #",
        "#####   ######...##",
        "    #####    #####"
    ],
    [
        "  ####",
        "  #  #########",
        " ##  ##  #   #",
        " #  $# $@$   ####",
        " #$  $  # $ $#  ##",
        "##  $## #$ $     #",
        "#  #  # #   $$$  #",
        "# $    $  $## ####",
        "# $ $ #$#  #  #",
        "##  ###  ###$ #",
        " #  #....     #",
        " ####......####",
        "   #....####",
        "   #...##",
        "   #...#",
        "   #####"
    ],
    [
        "      ####",
        "  #####  #",
        " ##     $#",
        "## $  ## ###",
        "#@$ $ # $  #",
        "#### ##   $#",
        " #....#$ $ #",
        " #....#   $#",
        " #....  $$ ##",
        " #... # $   #",
        " ######$ $  #",
        "      #   ###",
        "      #$ ###",
        "      #  #",
        "      ####"
    ],
    [
        " ###########",
        " #     ##  #",
        " #   $   $ #",
        "#### ## $$ #",
        "#   $ #    #",
        "# $$$ # ####",
        "#   # # $ ##",
        "#  #  #  $ #",
        "# $# $#    #",
        "#   ..# ####",
        "####.. $ #@#",
        "#.....# $# #",
        "##....#  $ #",
        " ##..##    #",
        "  ##########"
    ],
    [
        " #########",
        " #....   ##",
        " #.#.#  $ ##",
        "##....# # @##",
        "# ....#  #  ##",
        "#     #$ ##$ #",
        "## ###  $    #",
        " #$  $ $ $#  #",
        " # #  $ $ ## #",
        " #  ###  ##  #",
        " #    ## ## ##",
        " #  $ #  $  #",
        " ###$ $   ###",
        "   #  #####",
        "   ####"
    ],
    [
        "############ ######",
        "#   #    # ###....#",
        "#   $$#   @  .....#",
        "#   # ###   # ....#",
        "## ## ###  #  ....#",
        " # $ $     # # ####",
        " #  $ $##  #      #",
        "#### #  #### # ## #",
        "#  # #$   ## #    #",
        "# $  $  # ## #   ##",
        "# # $ $    # #   #",
        "#  $ ## ## # #####",
        "# $$     $$  #",
        "## ## ### $  #",
        " #    # #    #",
        " ###### ######"
    ],
    [
        "            #####",
        "#####  ######   #",
        "#   ####  $ $ $ #",
        "# $   ## ## ##  ##",
        "#   $ $     $  $ #",
        "### $  ## ##     ##",
        "  # ##### #####$$ #",
        " ##$##### @##     #",
        " # $  ###$### $  ##",
        " # $  #   ###  ###",
        " # $$ $ #   $$ #",
        " #     #   ##  #",
        " #######.. .###",
        "    #.........#",
        "    #.........#",
        "    ###########"
    ],
    [
        "###########",
        "#......   #########",
        "#......   #  ##   #",
        "#..### $    $     #",
        "#... $ $ #   ##   #",
        "#...#$#####    #  #",
        "###    #   #$  #$ #",
        "  #  $$ $ $  $##  #",
        "  #  $   #$#$ ##$ #",
        "  ### ## #    ##  #",
        "   #  $ $ ## ######",
        "   #    $  $  #",
        "   ##   # #   #",
        "    #####@#####",
        "        ###"
    ],
    [
        "      ####",
        "####### @#",
        "#     $  #",
        "#   $## $#",
        "##$#...# #",
        " # $...  #",
        " # #. .# ##",
        " #   # #$ #",
        " #$  $    #",
        " #  #######",
        " ####"
    ],
    [
        "             ######",
        " #############....#",
        "##   ##     ##....#",
        "#  $$##  $ @##....#",
        "#      $$ $#  ....#",
        "#  $ ## $$ # # ...#",
        "#  $ ## $  #  ....#",
        "## ##### ### ##.###",
        "##   $  $ ##   .  #",
        "# $###  # ##### ###",
        "#   $   #       #",
        "#  $ #$ $ $###  #",
        "# $$$# $   # ####",
        "#    #  $$ #",
        "######   ###",
        "     #####"
    ],
    [
        "           ########",
        "           #  ....#",
        "############  ....#",
        "#    #  $ $   ....#",
        "# $$$#$  $ #  ....#",
        "#  $     $ #  ....#",
        "# $$ #$ $ $########",
        "#  $ #     #",
        "## #########",
        "#    #    ##",
        "#     $   ##",
        "#  $$#$$  @#",
        "#    #    ##",
        "###########"
    ],
    [
        "    ############",
        "    #          ##",
        "    #  # #$$ $  #",
        "    #$ #$#  ## @#",
        "   ## ## # $ # ##",
        "   #   $ #$  # #",
        "   #   # $   # #",
        "   ## $ $   ## #",
        "   #  #  ##  $ #",
        "   #    ## $$# #",
        "######$$   #   #",
        "#....#  ########",
        "#.#... ##",
        "#....   #",
        "#....   #",
        "#########"
    ],
    [
        "           #####",
        "          ##   ##",
        "         ##     #",
        "        ##  $$  #",
        "       ## $$  $ #",
        "       # $    $ #",
        "####   #   $$ #####",
        "#  ######## ##    #",
        "#.            $$$@#",
        "#.# ####### ##   ##",
        "#.# #######. #$ $##",
        "#........... #    #",
        "##############  $ #",
        "             ##  ##",
        "              ####"
    ],
    [
        "     ########",
        "  ####      ######",
        "  #    ## $ $   @#",
        "  # ## ##$#$ $ $##",
        "### ......#  $$ ##",
        "#   ......#  #   #",
        "# # ......#$  $  #",
        "# #$...... $$# $ #",
        "#   ### ###$  $ ##",
        "###  $  $  $  $ #",
        "  #  $  $  $  $ #",
        "  ######   ######",
        "       #####"
    ],
    [
        "        #######",
        "    #####  #  ####",
        "    #   #   $    #",
        " #### #$$ ## ##  #",
        "##      # #  ## ###",
        "#  ### $#$  $  $  #",
        "#...    # ##  #   #",
        "#...#    @ # ### ##",
        "#...#  ###  $  $  #",
        "######## ##   #   #",
        "          #########"
    ],
    [
        " #####",
        " #   #",
        " # # #######",
        " #      $@######",
        " # $ ##$ ###   #",
        " # #### $    $ #",
        " # ##### #  #$ ####",
        "##  #### ##$      #",
        "#  $#  $  # ## ## #",
        "#         # #...# #",
        "######  ###  ...  #",
        "     #### # #...# #",
        "          # ### # #",
        "          #       #",
        "          #########"
    ],
    [
        "##### ####",
        "#...# #  ####",
        "#...###  $  #",
        "#....## $  $###",
        "##....##   $  #",
        "###... ## $ $ #",
        "# ##    #  $  #",
        "#  ## # ### ####",
        "# $ # #$  $    #",
        "#  $ @ $    $  #",
        "#   # $ $$ $ ###",
        "#  ######  ###",
        "# ##    ####",
        "###"
    ],
    [
        "##########",
        "#        ####",
        "# ###### #  ##",
        "# # $ $ $  $ #",
        "#       #$   #",
        "###$  $$#  ###",
        "  #  ## # $##",
        "  ##$#   $ @#",
        "   #  $ $ ###",
        "   # #   $  #",
        "   # ##   # #",
        "  ##  ##### #",
        "  #         #",
        "  #.......###",
        "  #.......#",
        "  #########"
    ],
    [
        "         ####",
        " #########  ##",
        "##  $      $ #####",
        "#   ## ##   ##...#",
        "# #$$ $ $$#$##...#",
        "# #   @   #   ...#",
        "#  $# ###$$   ...#",
        "# $  $$  $ ##....#",
        "###$       #######",
        "  #  #######",
        "  ####"
    ],
    [
        "  #########",
        "  #*.*#*.*#",
        "  #.*.*.*.#",
        "  #*.*.*.*#",
        "  #.*.*.*.#",
        "  #*.*.*.*#",
        "  ###   ###",
        "    #   #",
        "###### ######",
        "#           #",
        "# $ $ $ $ $ #",
        "## $ $ $ $ ##",
        " #$ $ $ $ $#",
        " #   $@$   #",
        " #  #####  #",
        " ####   ####"
    ],
    [
        "       ####",
        "       #  ##",
        "       #   ##",
        "       # $$ ##",
        "     ###$  $ ##",
        "  ####    $   #",
        "###  # #####  #",
        "#    # #....$ #",
        "# #   $ ....# #",
        "#  $ # #.*..# #",
        "###  #### ### #",
        "  #### @$  ##$##",
        "     ### $     #",
        "       #  ##   #",
        "       #########"
    ],
    [
        "        #####",
        "        #   #####",
        "        # #$##  #",
        "        #     $ #",
        "######### ###   #",
        "#....  ## $  $###",
        "#....    $ $$ ##",
        "#....  ##$  $ @#",
        "#########  $  ##",
        "        # $ $  #",
        "        ### ## #",
        "          #    #",
        "          ######"
    ],
    [
        "      ############",
        "     ##..    #   #",
        "    ##..* $    $ #",
        "   ##..*.# # # $##",
        "   #..*.# # # $  #",
        "####...#  #    # #",
        "#  ## #          #",
        "# @$ $ ###  #   ##",
        "# $   $   # #   #",
        "###$$   # # # # #",
        "  #   $   # # #####",
        "  # $# #####      #",
        "  #$   #   #    # #",
        "  #  ###   ##     #",
        "  #  #      #    ##",
        "  ####      ######"
    ],
    [
        " #########",
        " #       #",
        " # $ $$ $#",
        "### #  $ #",
        "#.#   $$ ##",
        "#.###   $ #",
        "#.#. $ ## ####",
        "#...  $## $  #",
        "#...$   $    #",
        "#..###$### #@#",
        "#..# #     ###",
        "#### #######"
    ],
    [
        "           ########",
        "           #......#",
        "   ####    #......#",
        "   #  #########...#",
        "   # $   $    #...#",
        "   #  # # # # #   #",
        "##### # # #@# #   #",
        "#   # ### ### ## ##",
        "#    $ # $ $ $ # #",
        "# $$$  $   #     #",
        "#   # ###$###$## #",
        "### #  $   #     #",
        " ## $  # $ $ $ ###",
        " #  # ### ### ##",
        " # $          #",
        " #  ###########",
        " ####"
    ],
    [
        "##################",
        "#                ##",
        "# $#   $ ##  $    #",
        "#    $###    # $$ #",
        "#.###     $ $ ##  ##",
        "#...#  #  #    #$  #",
        "#..##$$#### $  #   #",
        "#...#      $ ##  ###",
        "#...$  ###  #    # #",
        "##..  $#  ##   ##@ #",
        " ##.#              #",
        "  ##################"
    ],
    [
        "####################",
        "#   #    #   #   #@#",
        "# $      $   $   # #",
        "## ###..## ###     #",
        "#   #....#$#  $### #",
        "# $ #....#  $  $ $ #",
        "#   #....# # # $ $ #",
        "#   ##..##   #$#   #",
        "##$##    ##  #  #$##",
        "#   $  $     #  #  #",
        "#   #    #   #     #",
        "####################"
    ],
    [
        "####################",
        "#    @##      #   ##",
        "#    ##    $    $ ##",
        "#  ###....# # #  ###",
        "#   #....# # # $   #",
        "### #...#  #       #",
        "##  ##.#     $   $ #",
        "##  $ $ ###  # # ###",
        "## $       # # $   #",
        "#### $  $# # # # $ #",
        "####         # #  ##",
        "####################"
    ],
    [
        "####################",
        "#  #  ##    #   @###",
        "##    $    # $###  #",
        "##$# $ ##$# $ $    #",
        "#   $#    $      ###",
        "# ##   $ ###  #....#",
        "# # $# # # # #....##",
        "#    $ $ #  #....###",
        "##$ ###  $ #....####",
        "#  # $        ######",
        "#      # #    ######",
        "####################"
    ],
    [
        "####################",
        "#@     ###   #  #  #",
        "# # #  #  $  $     #",
        "#####     # $ $#$# #",
        "#.#..#    ##$ $    #",
        "#.....    $   #   ##",
        "#.....    ###$##$###",
        "#.#..#    $    #   #",
        "#####     #  #$  $ #",
        "#####  #  $    $ $ #",
        "#####  #  #  #  #  #",
        "####################"
    ],
    [
        "####################",
        "##...   ## #    #  #",
        "#....         $ ## #",
        "#....# # #$###$    #",
        "#...#    #       # #",
        "##.#  #$ #     $## #",
        "#  #  # $ $ ###  $ #",
        "#     $  $ #  # ## #",
        "## # ## #$$# $#  # #",
        "#  #   $ $ #      ##",
        "#    #     #  #   @#",
        "####################"
    ],
    [
        "####################",
        "#   #  #@# ##  #####",
        "# # #  $    $  #####",
        "# #    ###### $  ###",
        "#   #  #....#  $$  #",
        "##$##$##....#      #",
        "#      #....##$##$##",
        "#  $$  #....#      #",
        "# $  $  #  #  ###  #",
        "#####  $   $    $  #",
        "##### #    #  #   ##",
        "####################"
    ],
    [
        "######  ###",
        "#..  # ##@##",
        "#..  ###   #",
        "#..     $$ #",
        "#..  # # $ #",
        "#..### # $ #",
        "#### $ #$  #",
        "   #  $# $ #",
        "   # $  $  #",
        "   #  ##   #",
        "   #########"
    ],
    [
        "####################",
        "# #     #          #",
        "#       $  ## ### ##",
        "#####  ##   $  $   #",
        "##..##  # # $ # #  #",
        "#....  $     ##$# ##",
        "#....  $#####   #$##",
        "##..# #  #   #  $  #",
        "###.# #  $   $  # @#",
        "##  $  $ #   #  ####",
        "##       ###########",
        "####################"
    ],
    [
        "####################",
        "#     ###..###     #",
        "# $$  ###..###  $@ #",
        "#  # ##......#  $  #",
        "#     #......#  $  #",
        "####  ###..######$ #",
        "#   $$$ #..#    #  #",
        "# $#   $  $  $$ #$ #",
        "#  #  ## $  ##  #  #",
        "# $    $ ## $    $ #",
        "#  #  ##    ##  #  #",
        "####################"
    ],
    [
        "####################",
        "#    #  # #  #  #  #",
        "# @# # ## $   $   ##",
        "#### #    #  # $   #",
        "#    # ## #$ ## ## #",
        "#      $   $   $   #",
        "#..###$$## $##$ ## #",
        "#..#.#  # $   $ #  #",
        "#....# $$   ##$ ####",
        "#....#  #####      #",
        "#...###        ##  #",
        "####################"
    ],
    [
        "####################",
        "#....#       #  #  #",
        "#....# # $  $      #",
        "#.... ##  $# # $#$ #",
        "#...#   $   $#  $  #",
        "#..####  # $   $$  #",
        "#      #### #### ###",
        "#        #   #     #",
        "# ##   #   $ # $ $ #",
        "# ##    $ ## $  $  #",
        "#     @#     #   # #",
        "####################"
    ],
    [
        "####################",
        "#....###           #",
        "#....##### #  #$# ##",
        "#....###   #$  $   #",
        "#....###    $  #$$##",
        "##  #### $#  #$ $  #",
        "##  ####  $  $  #  #",
        "#@  ####$###$## $  #",
        "##        #  #  $  #",
        "##   ###  #  $  ####",
        "########  #  #     #",
        "####################"
    ],
    [
        "####################",
        "#     #     @#...###",
        "#     #      ##...##",
        "# # # ##$## ## ....#",
        "#   $ #   $$$  ....#",
        "###$### $$  ### ##.#",
        "#     $  #    # ####",
        "#  $  #  ###  # #  #",
        "## #$##    $  $$   #",
        "#   $ ##   #  # #  #",
        "#     #    #  #    #",
        "####################"
    ],
    [
        "####################",
        "#     #  #...#@    #",
        "# #       ....#    #",
        "#  $  #   #....#   #",
        "# ##$#### ##....#  #",
        "# $   $  #  #...#  #",
        "# $$ #   #   # $$  #",
        "###  $$$#   $$  $  #",
        "# $  #  #    # $#  #",
        "#   $#  #       $  #",
        "#  #    #    #  #  #",
        "####################"
    ],
    [
        "####################",
        "#####@###.##...##  #",
        "#####$  ..#...#    #",
        "####    ......#  $ #",
        "###  $ #.....## # ##",
        "##  $$# #####  $ $ #",
        "## $# $    ##  $$  #",
        "##  #  #    # $  $ #",
        "##   $$ ### #$##   #",
        "## $#      $ $  $ ##",
        "###    #    #    ###",
        "####################"
    ],
    [
        "####################",
        "#@     #   #       #",
        "## ### ##  #### # ##",
        "#    # #  $$       #",
        "#  # # # $ # $ ## ##",
        "#     $ #  #$$ #   #",
        "#  ###  #      ## ##",
        "#..#.# $ #  $ #    #",
        "#..#.#  $ # ## $$  #",
        "#....##   $$  $  # #",
        "#.....##        #  #",
        "####################"
    ],
    [
        "####################",
        "#  #      #   #   ##",
        "# $# $ $ ##...$  $ #",
        "#  $  # ##....# $  #",
        "# ## $ ##....#   $ #",
        "# $    #....## $   #",
        "# $##  #...#       #",
        "#   $$$##$##  ### ##",
        "# # #  #   #  #    #",
        "# $ #  $  ##       #",
        "#    #    #@       #",
        "####################"
    ],
    [
        "       #####",
        " #######   ##",
        "## # @## $$ #",
        "#    $      #",
        "#  $  ###   #",
        "### #####$###",
        "# $  ### ..#",
        "# $ $ $ ...#",
        "#    ###...#",
        "# $$ # #...#",
        "#  ### #####",
        "####"
    ],
    [
        "####################",
        "#  #  # #    #  #  #",
        "#   $      $ $     #",
        "## #  #$###$##  ## #",
        "#   $     $  #  $  #",
        "# ###$##$#   # $   #",
        "# #   $ $  ###### $#",
        "# $  $$ $  #@#.#...#",
        "# #     #  # #.#...#",
        "# ########## #.....#",
        "#            #.....#",
        "####################"
    ],
    [
        "####################",
        "#  #     #  ##    ##",
        "# $#   $ #     ##  #",
        "# $  $  #..#     $ #",
        "# $ $  #....#   # ##",
        "# $#  #......### $ #",
        "#   #  #....#  #$  #",
        "# $  ####..#   #   #",
        "## $   ## # # $  $##",
        "### $    $#@$ $#   #",
        "####   #       #   #",
        "####################"
    ],
    [
        "####################",
        "#      ....#    ####",
        "#      ....        #",
        "# # ##########     #",
        "# #$   #      ###..#",
        "#  $   #$$###   #..#",
        "# $ ### $   $   #..#",
        "# $ #   $ $ #  ##..#",
        "#  #  $$ # $ ##   ##",
        "#@## $#  $  $     ##",
        "##       ##   #  ###",
        "####################"
    ],
    [
        "####################",
        "#        #   #@ #  #",
        "# $$  #$$# # #  ## #",
        "#  # $ $ #$$ #     #",
        "## #  #  # # #  #  #",
        "#   ##       #     #",
        "#   # $ #   #   #  #",
        "# $ #$ #   #  $ #..#",
        "##$ #  ####    #...#",
        "#  $          #....#",
        "#   #  #     #.....#",
        "####################"
    ],
    [
        "####################",
        "#     #   #####    #",
        "## $  #   ####  $  #",
        "#### $$   #..#  #  #",
        "#  $  $  ##..#### ##",
        "# $   ###....   $$ #",
        "#  #$#   ....# # $ #",
        "# #  # $ ..###$#   #",
        "# #   $ #..#   ##  #",
        "#   $#  ####   # $##",
        "# #  #    @#      ##",
        "####################"
    ],
    [
        "####################",
        "#   #   #    #   #@#",
        "#   $  $     # $ # #",
        "##$# $### #    $$# #",
        "#  #  #.###  #$ $  #",
        "#  #$#....#  # ### #",
        "# $  #.....##    # #",
        "##$  #.#....#$$ $  #",
        "#  ######..## #  # #",
        "#  $         $ ### #",
        "#   #   #        # #",
        "####################"
    ],
    [
        "####################",
        "# # # #   #@##   # #",
        "#             $    #",
        "#  ##$# ##### $ # ##",
        "##    ##.....#  #  #",
        "##$##$#.....###$#$ #",
        "#   # ##.....#  # ##",
        "#  $    ##..##  #  #",
        "# $ #   $   $  $$$ #",
        "## $  $# #  #  $   #",
        "#   ##   #  #      #",
        "####################"
    ],
    [
        "####################",
        "#    ##   #    #   #",
        "#  $  $     ## $   #",
        "## #####  .###### ##",
        " # ##  ##....#### ##",
        "## ##$ ###..##     #",
        "#      #... .# $ $ #",
        "# $ ## ## . ### ####",
        "# # $    #.## # #",
        "# $ $ #   .#### ##",
        "# #  ## # ##  #  ##",
        "#######  $##$   $ #",
        "      ##      $ #@#",
        "       #  ## ######",
        "       #######"
    ],
    [
        "       ###########",
        "       #         #",
        "       #    $ $  #",
        "###### # $ ##### #",
        "#    ##### $  ##$#",
        "#       $ $      #",
        "#          ## ## #",
        "#    ##@##### ## #",
        "#    ####   # ## ##",
        "#....#      # $   #",
        "#....#      #     #",
        "######      #######"
    ],
    [
        "#############",
        "#           #",
        "# ### $$    #",
        "#   # $  $  #",
        "#  $####$######",
        "# $ ##        #####",
        "#  $$ $        ...#",
        "### ## $$#     ...#",
        "  # ##   #     ...#",
        "  #      #     ...#",
        "  ###@#############",
        "    ###"
    ],
    [
        "  ####",
        "  #  ###########",
        "  #    $   $ $ #",
        "  # $# $ #  $  #",
        "  #  $ $  #    #",
        "### $# #  #### #",
        "#@#$ $ $  ##   #",
        "#    $ #$#   # #",
        "#   $    $ $ $ #",
        "#####  #########",
        "  #      #",
        "  #      #",
        "  #......#",
        "  #......#",
        "  #......#",
        "  ########"
    ],
    [
        "  #################",
        "###@##         ...#",
        "#    #         ...#",
        "# $  #         ...#",
        "# $$ #         ...#",
        "## $ ###$##########",
        " # ###  $ #",
        "##   $  $ #",
        "#  $ #  $ #",
        "# $  #    #",
        "#  $ #    #",
        "#    #    #",
        "###########"
    ],
    [
        "              #####",
        "     ##########   #",
        "     #        #   #",
        "     #  $ $    $$ #",
        "     # ##### ## $ #",
        "     #$$   #$## $ #",
        "     # ### # ##$  #",
        "###### ### $ $    #",
        "#....        ##   #",
        "#....        ######",
        "#....        #",
        "###########@##",
        "          ###"
    ],
    [
        "    ######",
        " ####    #",
        " #    ## #",
        " # $     #",
        "### #### ########",
        "#  $   $ ##  ...#",
        "#   $$ $$    ...#",
        "#    $  $##  ...#",
        "##@## ## ##  ...#",
        " ###  $  ########",
        " #   $$  #",
        " #    #  #",
        " #########"
    ],
    [
        "####### #########",
        "#     # #   ##  #",
        "# ### # #   $   #",
        "# # $ ###   $   #",
        "#   $$      ##$ #",
        "#    ####   ##  #",
        "#@############ ##",
        "###..    #####$ #",
        "  #..    ####   #",
        "  #..       $$  #",
        "  #..    #### $ #",
        "  #..    #  #   #",
        "  ########  #####"
    ],
    [
        "#######",
        "#     ##########",
        "#     #    #  ##",
        "# $   #   $ $  #",
        "#  $  #  $ ##  #",
        "# $$  ##$ $    #",
        "## #  ## #######",
        "## #  ##    ...#",
        "#  #$       ...#",
        "#   $$      ...#",
        "#     ##@#  ...#",
        "################"
    ],
    [
        "############",
        "#      #   ##",
        "# $  $   #  ######",
        "####  #####      #",
        " #..  #     #### #",
        " #.####  ####    #",
        " #....    #  $ ####",
        " # ...#   # $$$#  ##",
        "###.#### ##  $@$   #",
        "#     ##### $ #    #",
        "# #.# $      $###$ #",
        "# #.########  #  $ #",
        "# #..        ##  $ #",
        "# # ####### $ # #  #",
        "#   #     #       ##",
        "#####     ##########"
    ],
    [
        "################",
        "#       #@ #   #",
        "# # # # # $  $$#",
        "# #...# #$$$   #",
        "#  ...# # $  $$##",
        "# ##.## # ##    #",
        "# #...     $    #",
        "# ## ###  #######",
        "#    # ####",
        "######"
    ],
    [
        "    #####",
        " ####   ## #####",
        " #  $    ###   #",
        " # $@$ $    $  #",
        " # #$######## ##",
        " # #  $  #     #",
        " # # $ $ # #   #",
        "## #  $# # #####",
        "#  ##    #     #",
        "#    $ # ###   #",
        "##### ##  #....#",
        "#    $     ....#",
        "#         #....#",
        "################"
    ],
    [
        "#############",
        "#........####",
        "#...#### #  #####",
        "#...#  ###    $ #",
        "#...$$     $ $  #",
        "#  .#  $ $# $  ##",
        "#...# #$#   $  #",
        "#.# # $   $    #",
        "#.  #$###$####$#",
        "##  #   $ $    #",
        " #  #  $@$  #  #",
        " #  # #### $  $#",
        " #  #    ###   #",
        " #  # $$ # #####",
        " #  #    #",
        " #########"
    ],
    [
        " ##################",
        " #   $       ...#.##",
        " #       ####..... #",
        " # #######  #..... #",
        " # #    $ $ ##....##",
        " # #  $ # # ###...#",
        " # # $@$ $  ##### #",
        "## #  $  $ $$   $ #",
        "#  #$# $#   # $## #",
        "# ##    ## ## $ # #",
        "# # $# $ $  #     #",
        "# #         #######",
        "# ########$##   #",
        "#        #  $   #",
        "########    #####",
        "       ###  #",
        "         ####"
    ],
    [
        "          #######",
        "          #  ...#",
        "      #####  ...#",
        "      #      . .#",
        "      #  ##  ...#",
        "      ## ##  ...#",
        "     ### ########",
        "     # $$$ ##",
        " #####  $ $ #####",
        "##   #$ $   #   #",
        "#@ $  $    $  $ #",
        "###### $$ $ #####",
        "     #      #",
        "     ########"
    ],
    [
        "####################",
        "#..#    #          #",
        "#.$  $  #$$  $## $##",
        "#.$#  ###  ## ##   #",
        "#  # $ #  $$   $   #",
        "# ###  # #  #$  ####",
        "#  ## # $   #@ #   #",
        "# $    $  ##.##  $ #",
        "#  # $# $# $     ###",
        "#  #  #  #   ###   #",
        "#  ######## #      #",
        "#           #  #.#.#",
        "##$########$#   ...#",
        "#    .*  #    ##.#.#",
        "# .*...*   $  .....#",
        "####################"
    ]
]